/**
 * Website Information Configuration
 * Centralized data for contact information, address, and social media links
 */

const websiteInfo = {
    address: {
        full: "45th St, Nanganallur, Chennai, Tamil Nadu 600061",
        street: "45th St",
        area: "Nanganallur",
        city: "Chennai",
        state: "Tamil Nadu",
        pincode: "600061"
    },
    contact: {
        phone: [
            {
                number: "+91 9790656776",
                display: "+91 9790656776",
                link: "tel:+919790656776"
            }
        ],
        email: [
            {
                email: "contact@adrocketagency.com",
                display: "contact@adrocketagency.com",
                link: "mailto:contact@adrocketagency.com"
            }
        ]
    },
    socialMedia: {
        facebook: {
            name: "Facebook",
            url: "https://www.facebook.com/share/17A1jbMYCB/?mibextid=wwXIfr",
            icon: "fa-brands fa-facebook-f"
        },
        instagram: {
            name: "Instagram",
            url: "https://www.instagram.com/adrocketagency_official/",
            icon: "fa-brands fa-instagram"
        },
        linkedin: {
            name: "LinkedIn",
            url: "https://www.linkedin.com/company/106711759/admin/dashboard/",
            icon: "fa-brands fa-linkedin-in"
        }
    },
    maps: {
        embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.849269541564!2d80.1875597!3d12.981490899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525db2be4f552b%3A0x6868d7a80a8d4e93!2sImperial%20Homes%20Nanganallur!5e0!3m2!1sen!2sin!4v1770044862177!5m2!1sen!2sin"
    }
};

export default websiteInfo;

